import { Tooltip } from '@betterment/samba-react';

export const TaxLossHarvestingTooltip = ({ isEnabled }: { isEnabled: boolean }) => {
  const enabledModifier = isEnabled ? '' : 'can ';
  const tooltipText = `We ${enabledModifier}actively monitor eligible accounts for opportunities to sell holdings at a loss to help reduce your taxes.`;

  return (
    <Tooltip>
      <Tooltip.Trigger asChild={true}>
        <Tooltip.IconButton css={{ ml: 'space.50' }} />
      </Tooltip.Trigger>
      <Tooltip.Content align="start" side="left">
        <Tooltip.Text>{tooltipText}</Tooltip.Text>
      </Tooltip.Content>
    </Tooltip>
  );
};
